module.exports = __webpack_public_path__ + "static/media/spotify-Tamar-Kaprelian-Ali-Tamposi-billboard-1548-1634827558-compressed.db60370c.jpg";